import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Stack } from '@chakra-ui/react';
import React from 'react';
import Text from '../Text';

var Testimonial = function Testimonial(props) {
  var title = props.title,
      author = props.author,
      content = props.content,
      date = props.date,
      rest = _objectWithoutPropertiesLoose(props, ["title", "author", "content", "date"]);

  return /*#__PURE__*/React.createElement(Stack, Object.assign({
    w: "100%",
    maxW: "70ch",
    align: "center",
    spacing: 4,
    textAlign: "center"
  }, rest), /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    color: "white",
    fontWeight: "700"
  }, title), /*#__PURE__*/React.createElement(Text, {
    color: "white",
    fontWeight: "400"
  }, content), /*#__PURE__*/React.createElement(Text, {
    color: "white",
    fontWeight: "700",
    alignSelf: "flex-end"
  }, author + ", " + date));
};

export default Testimonial;